import { StyleSheet, View, Text, Pressable, SafeAreaView } from "react-native";
import React from "react";
import { useAppSelector } from "../../../hooks/reduxHooks";
import { getPrimaryColor } from "../../../utils/ColorsFunctions";
import { Ionicons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";

const AuthStackHeader = () => {
	const navigation = useNavigation();
	const user = useAppSelector(s => s.auth.subUser!);

	return (
		<SafeAreaView style={styles.root}>
			<Pressable style={styles.pressable} onPress={navigation.goBack}>
				<Ionicons name="chevron-back" size={24} color={getPrimaryColor(user)} />
				<Text style={[styles.text, { color: getPrimaryColor(user) }]}>
					Voltar
				</Text>
			</Pressable>
		</SafeAreaView>
	);
};

export default AuthStackHeader;

const styles = StyleSheet.create({
	root: {
		backgroundColor: "#fff",
	},
	pressable: {
		flexDirection: "row",
		alignItems: "center",
		width: 100,
		backgroundColor: "#fff",
		padding: 11,
		paddingBottom: 20,
	},
	text: {
		fontWeight: "600",
		marginLeft: 10,
		fontSize: 15,
	},
});
